module.exports = __webpack_public_path__ + "img/cramera_des_4.12dd48af.jpg";